import { CONSTANTS } from 'wmic-portals-utils-js';

/**
 * Account Management Portal data layer initialization for Adobe Analytics/Tealium.
 * Mirrors quote-and-buy UDO naming while using AMP-specific defaults.
 */

const getAuthenticationStatus = () => {
    const isAuthenticated = localStorage.getItem(CONSTANTS.AMP_LOCAL_STORAGE.USER_lOGGEDIN.NAME)
        || sessionStorage.getItem('X_GWRE_SESSION');

    return isAuthenticated ? 'logged in' : 'logged out';
};

const getPlatform = () => {
    const userAgent = navigator.userAgent || '';
    const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    return isMobile ? 'Mobile' : 'Desktop';
};

const deepMerge = (target, source) => {
    Object.keys(source || {}).forEach((key) => {
        const sourceValue = source[key];
        if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
            target[key] = target[key] || {};
            deepMerge(target[key], sourceValue);
            return;
        }
        target[key] = sourceValue;
    });
};

const getInitialDataLayer = () => ({
    category: ['insurance service'],
    channel: 'insurance',
    subchannel1: 'account management',
    subchannel2: 'servicing',
    page: '',
    product: ['account management'],
    quantity: ['1'],
    IsAuthenticated: getAuthenticationStatus(),
    sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
    ins_quoteid: '',
    ins_quote_id: '',
    // Pre-authentication pages (enrollment/recovery) have no account data to derive jurisdiction from; default to CA.
    state: 'ca',
    flow: 'servicing',
    cta: '',
    error: '',
    platform: getPlatform(),
    premium: '',
    pageurl: window.location.href
});

export const updateDataLayer = (updates = {}) => {
    if (!window.wins_data_layer) {
        window.wins_data_layer = getInitialDataLayer();
    }

    deepMerge(window.wins_data_layer, updates);
};

export function initializeDataLayer() {
    window.wins_data_layer = getInitialDataLayer();

    window.updateDataLayer = updateDataLayer;
}

export default {
    initializeDataLayer,
    updateDataLayer
};
